// extracted by mini-css-extract-plugin
export default {"version":"AppContent-styles-module__version___zxsi"};